import { useCallback } from 'react'
import { useAuthContext } from 'shared/components/AuthContext'
import { usePasswordPolicyWarning } from 'shared/components/PasswordPolicyContext'
import { clearSharedAuthTime, ItemTag, resetViewerMode } from 'shared/utils'

export const useSignOut = () => {
  const { auth } = useAuthContext()
  const { hidePasswordPolicyWarning } = usePasswordPolicyWarning()

  return useCallback(async () => {
    try {
      await auth?.signOut()
    } finally {
      hidePasswordPolicyWarning()
      resetViewerMode()
      localStorage.removeItem(ItemTag.CUSTOM_CREDENTIALS_HISTORY)
      clearSharedAuthTime()
    }
  }, [auth, hidePasswordPolicyWarning])
}
